/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimilarProfileReviews
 */
export interface SimilarProfileReviews {
    /**
     * 
     * @type {number}
     * @memberof SimilarProfileReviews
     */
    averageRating?: number;
    /**
     * 
     * @type {number}
     * @memberof SimilarProfileReviews
     */
    numberOfRatings?: number;
}

/**
 * Check if a given object implements the SimilarProfileReviews interface.
 */
export function instanceOfSimilarProfileReviews(value: object): value is SimilarProfileReviews {
    return true;
}

export function SimilarProfileReviewsFromJSON(json: any): SimilarProfileReviews {
    return SimilarProfileReviewsFromJSONTyped(json, false);
}

export function SimilarProfileReviewsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarProfileReviews {
    if (json == null) {
        return json;
    }
    return {
        
        'averageRating': json['averageRating'] == null ? undefined : json['averageRating'],
        'numberOfRatings': json['numberOfRatings'] == null ? undefined : json['numberOfRatings'],
    };
}

export function SimilarProfileReviewsToJSON(value?: SimilarProfileReviews | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'averageRating': value['averageRating'],
        'numberOfRatings': value['numberOfRatings'],
    };
}

